import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Text,
  Stack,
  Icon,
} from '@chakra-ui/react';
import { FaUser, FaEnvelope, FaSignInAlt, FaCalendarAlt } from 'react-icons/fa';
import axiosInstance from '../services/axiosInstance';
import { formatDistanceToNow } from 'date-fns';
const getTimeAgo = (isoDateString) => {
  if (!isoDateString) return 'لم يتم تسجيل الدخول بعد';
  
  const date = new Date(isoDateString);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  };
  return date.toLocaleString('ar-TN', options);
};

const UserLastLoginModal = ({ isOpen, onClose, userdata }) => {
  const [lastLogin, setLastLogin] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && userdata) {
      setLastLogin(userdata.lastlogin)
    }
  }, [isOpen, userdata]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent dir="rtl">
        <ModalHeader color="blue.600" textAlign="right">معلومات آخر دخول</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={6}>
            <Box>
              <Text fontSize="lg" fontWeight="bold" textAlign="right">
                <Icon as={FaUser} color="yellow.400" ml={2} />
                المستخدم: {userdata?.username || 'غير محدد'}
              </Text>
              <Text textAlign="right">
                <Icon as={FaEnvelope} color="gray.500" ml={2} />
                البريد الإلكتروني: {userdata?.email || 'غير محدد'}
              </Text>
            </Box>

            {loading ? (
              <Text color="gray.500" textAlign="right">جاري تحميل البيانات...</Text>
            ) : (
              <Box textAlign="right">
                <Text fontSize="md" fontWeight="bold" mb={4}>
                  <Icon as={FaSignInAlt} color="teal.500" ml={2} />
                  آخر دخول:
                </Text>
                
                <Box p={4} borderWidth="1px" borderRadius="lg" bg="gray.50">
                  <Text fontSize="lg" mb={2}>
                    <Icon as={FaCalendarAlt} color="blue.500" ml={2} />
                    {lastLogin ? getTimeAgo(lastLogin) : 'لا يوجد سجل دخول'}
                  </Text>
                  
                  {lastLogin && (
                    <Text fontSize="sm" color="gray.600">
                      (منذ {formatDistanceToNow(new Date(lastLogin))})
                    </Text>
                  )}
                </Box>
              </Box>
            )}
          </Stack>
        </ModalBody>
        <ModalFooter justifyContent="flex-start">
          <Button colorScheme="blue" onClick={onClose} borderRadius="lg">
            إغلاق
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UserLastLoginModal;